<template>
  <Button
    color="shade-white"
    :to="addDomainPath"
  >
    <Icon color="primary" left icon="$arrows-cycle-check-outline" iconSize="small"/>
    <span class="primary--text" v-text="lc.label"/>
  </Button>
</template>

<script>
import { Button, Icon } from '@locaweb/design-system-vue'

export default {
  name: 'SwitchButton',
  components: {
    Button,
    Icon
  },
  computed: {
    lc () {
      return this.$lc('domains.manageDomain.domainCard.switchButton')
    },
    addDomainPath () {
      return { name: 'addDomain' }
    }
  }
}
</script>
